import moment from 'moment';
import _ from 'lodash';

export const parseDate = date => {
    const momentDate = moment(date, 'YYYY-MM-DD HH:mm:ss');
    const currentDate = moment().format('DD-MM-YYYY');
    const messageDate = moment(momentDate).format('DD-MM-YYYY');

    if(currentDate === messageDate) {
        return moment(momentDate).format('DD-MM-YYYY HH:mm:ss');
    }

    return moment(momentDate).format('DD-MM-YYYY HH:mm:ss');
}

export const filterByValuesMessages = (data, filterValues, file_type_id = false) => {

        // -- pearl of evan
      const reportValues = filterValues;

        const files = data;
        let filteredFiles = [];

        // -- Loop through all files
        for(let iFiles = 0; iFiles <= files.length; iFiles++) {

            // -- Default allow for array
            let currentFile = false;
            let hasBeenFalse = false;

            if(files[iFiles]) {
                currentFile = files[iFiles];

                if(file_type_id) {
                    // -- check for same file type id
                    if(currentFile.file_type_id !== file_type_id)
                    {
                        continue;
                    }
                }

                // -- Loop through report values
                for (let key in reportValues) {
                    let categoryIndex = _.findIndex(currentFile.metaDataCategories, function(a)  {return a === key});

                    if(categoryIndex >= 0) {
                        if(currentFile.metaDataValues) {
                            if(currentFile.metaDataValues[categoryIndex] !== reportValues[key]) {
                                hasBeenFalse = true;
                            }
                        } else {
                            hasBeenFalse = true;
                        }

                    } else {
                        hasBeenFalse = true;
                    }
                }

                // -- All values found; Add to array.
                if(!hasBeenFalse) {
                    filteredFiles.push(currentFile);
                }
            }
        }

        if(filteredFiles.length <= 0) {
            return [];
        }else{
            return filteredFiles;
        }
}

export const filterByValues = (data, filterValues, file_type_id = false) => {

    // -- pearl of evan
  const reportValues = filterValues;

    const files = data;
    let filteredFiles = [];

    // -- Loop through all files
    for(let iFiles = 0; iFiles <= files.length; iFiles++) {

        // -- Default allow for array
        let currentFile = false;
        let metaCategory = false;
        let hasBeenFalse = false;

        if(files[iFiles]) {
            currentFile = files[iFiles];

            if(file_type_id) {
                // -- check for same file type id
                if(currentFile.file_type_id !== file_type_id)
                {
                    continue;
                }
            }

            // -- Loop through report values
            for (let key in reportValues) {
                if (reportValues.hasOwnProperty(key)) {
                    if(key.includes('date_')) {
                        continue;
                    }
                    // -- Check if is a text value
                    if(key.includes('_text')) {

                        // -- Cast key to INT
                        let keyToUse = parseInt(key.replace('_text', ''), 10);

                        // -- Get metacategory
                        metaCategory = currentFile.metaDataCategorized[keyToUse];
                        if(metaCategory) {
                            if(metaCategory.includes(reportValues[key])){

                            }else{
                                hasBeenFalse = true;
                            }
                        }else{
                            hasBeenFalse = true;
                        }
                    }else{
                        // -- Cast key to INT
                        let keyToUse = parseInt(key, 10);

                        // -- Get metacategory
                        metaCategory = currentFile.metaDataCategorizedWithIds[keyToUse];
                          // -- multiselect filter
                        if(metaCategory) {
                            let strResult = reportValues[key];

                            if(strResult.includes(',')) {
                                let aValues = reportValues[key].split(",");

                                for(let i = 0; i <= aValues; i++) {
                                    if(aValues[i]) {
                                        if(metaCategory.includes(aValues[i])){

                                        }
                                    }
                                }
                            }else{

                               if(metaCategory.includes(reportValues[key])){

                                }else{
                                    hasBeenFalse = true;
                                }
                            }
                        }else{
                            hasBeenFalse = true;
                        }
                    }
                }
            }

            // -- All values found; Add to array.
            if(!hasBeenFalse) {
                filteredFiles.push(currentFile);
            }
        }
    }

    if(filteredFiles.length <= 0) {
        return false;
    }else{
        return filteredFiles;
    }
}



// WEBPACK FOOTER //
// ./src/Helpers/HelperFunctions.js